import { AccountType, Position, PositionType } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal } from '@synergy/components';
import { getLocalizedString } from '@synergy/utils';
import { useEffect, useState } from 'react';

import { PoolPositionAutocompleteList } from '../../../../common/components/autocomplete-list/position-autocomplete-list/pool-position-autocomplete-list';
import { localesSelector } from '../../../../common/selectors/locale-selectors';
import { useAppSelector } from '../../../../store/use-appstate-selector';

export interface ChangePositionModalProps {
    employeeType: AccountType;
    isVisible: boolean;
    position?: Position;
    onConfirm: (position: Position | null) => void;
    onCancel: () => void;
}

export const ChangePositionModal = (props: ChangePositionModalProps) => {
    const { isVisible, employeeType, onConfirm, onCancel } = props;
    const [position, setPosition] = useState<Position | null>(props.position ?? null);
    const locales = useAppSelector(localesSelector);

    useEffect(() => {
        setPosition(props.position ?? null);
    }, [props.position]);

    const handleConfirm = () => {
        onConfirm(position);
        setPosition(null);
    };
    const handleCancel = () => {
        onCancel();
        setPosition(null);
    };

    return (
        <PoolModal
            title={
                props.position ? (
                    <FormattedMessage id="app.contactsAndOrganizations.detail.changePosition" />
                ) : (
                    <FormattedMessage id="app.contactsAndOrganizations.detail.addPosition" />
                )
            }
            isVisible={isVisible}
            actionChildren={[
                <PoolButton key="1" variant="text" styleType="firstLevel" onClick={handleCancel}>
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>,
                <PoolButton key="2" styleType="firstLevel" onClick={handleConfirm}>
                    <FormattedMessage id={props.position ? 'app.common.change' : 'app.common.add'} />
                </PoolButton>,
            ]}
            handleClose={handleCancel}
        >
            <PoolPositionAutocompleteList
                label={<FormattedMessage id="app.header.position" />}
                types={[
                    PositionType.All,
                    employeeType === AccountType.Customer ? PositionType.Customer : PositionType.Supplier,
                ]}
                onSelected={position => setPosition(position)}
                disablePreventOverflow={true}
                required={true}
                value={(position && { id: position.id, name: getLocalizedString(locales, position.name) }) ?? undefined}
            />
        </PoolModal>
    );
};
